module.exports = __webpack_public_path__ + "img/wx.31a11c31.png";